const a = "saas-shared-ui", e = (s) => [a, ...s];
export {
  e as saasUiQueryKey
};
